<template>
  <!-- This component handles interstitial ads programmatically -->
  <div v-if="false"></div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import { admobService } from '../services/admobService';
import { useConsentStore } from '../stores/consentStore';

interface Props {
  trigger?: 'download' | 'navigation' | 'manual';
  frequency?: number; // Show ad every N triggers
}

const props = withDefaults(defineProps<Props>(), {
  trigger: 'manual',
  frequency: 3
});

const consentStore = useConsentStore();
const triggerCount = ref(0);
const lastShownTime = ref(0);

const isNative = computed(() => Capacitor.isNativePlatform());
const shouldShowAd = computed(() => {
  return consentStore.canUseAdvertising && admobService.isEnabled() && isNative.value;
});

const canShowAd = computed(() => {
  const now = Date.now();
  const timeSinceLastAd = now - lastShownTime.value;
  const minInterval = 30000; // 30 seconds minimum between ads
  
  return shouldShowAd.value && 
         triggerCount.value % props.frequency === 0 && 
         timeSinceLastAd > minInterval;
});

const showInterstitialAd = async (): Promise<boolean> => {
  if (!canShowAd.value) {
    return false;
  }

  try {
    const success = await admobService.showInterstitialAd();
    if (success) {
      lastShownTime.value = Date.now();
      triggerCount.value = 0; // Reset counter after showing ad
    }
    return success;
  } catch (error) {
    console.error('Failed to show interstitial ad:', error);
    return false;
  }
};

const incrementTrigger = () => {
  triggerCount.value++;
};

// Expose methods to parent components
defineExpose({
  showInterstitialAd,
  incrementTrigger,
  canShowAd
});
</script>